// extracted by mini-css-extract-plugin
export default {"container":"MenuBar_container__Xivs6","item":"MenuBar_item__Q5aUR","selectedItem":"MenuBar_selectedItem__3Cb3L"};